<template>
  <div class="gjw-tabs">
    <div class="tabs-header">
      <ul class="tabs-names">
        <li class="tab-name" :style="tabStyle" v-for="(tab,index) in tabs" :key="index" :class="{'tab-selected':currentIndex===index}" @click="clickTab(tab,index)">
          <span class="name">{{tab.name}}</span>
        </li>
      </ul>
    </div>
    <gjw-dimensions @height-changed="handleHeightChanged">
      <div class="tabs-content">
        <ul class="tabs-content-list">
          <li class="content"  v-for="(tab,index) in tabs" :key="index" :style="{'display':currentIndex === index ? 'block' : 'none'}">
            <slot :name="`content-${tab.id}`" :tab="tab"></slot>
          </li>
        </ul>
      </div>
    </gjw-dimensions>
  </div>
</template>

<script>
import GjwDimensions from '@/components/lib/GjwDimensions'
export default {
  components: { GjwDimensions },
  props: {
    tabs: {
      type: Array,
      default() {
        return []
      }
    },
    size: {
      type: String,
      default: 'large'
    }
  },
  data() {
    return {
      currentIndex: 0,
      largeSize: 'line-height: 1.7143rem;font-size: 1.1429rem;padding: 0.83rem 0.7143rem;margin-left: 1.4286rem;',
      smallSize: 'line-height: 1.4286rem;font-size: 1rem;padding: 1rem 0.83rem 0.6667rem;margin-left: 0px;'
    }
  },
  computed: {
    tabStyle() {
      return this.size === 'large' ? this.largeSize : this.smallSize
    }
  },
  methods: {
    reset() {
      this.currentIndex = 0
    },
    clickTab(tab, index) {
      this.currentIndex = index
      this.$emit('tab-clicked', { ...tab, index })
    },
    handleHeightChanged(obj) {
      this.$emit('contentSizeChanged', obj)
    }
  }

}
</script>

<style lang="less" scoped>
.gjw-tabs{
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .tabs-header{
    background: #fff;
    position: relative;
    &::after{
      position: absolute;
      bottom: 0;
      left: 0;
      content: '';
      width: 100%;
      height: 1px;
      background: @theme-border-color;
    }
  }
  .tabs-names{
    height: 100%;
    display: flex;
    flex-direction: row;

  }
  .tab-name{
    cursor: pointer;
    margin-right: 0.4286rem;
    margin-bottom: -1px;
    color: @theme-grey-1;
    &.tab-selected{
      position: relative;
      &::after{
        position: absolute;
        content: '';
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3px;
        background: @theme-color;
        z-index: 2;
      }
    }
  }
  .tabs-content{
    flex-grow: 1;
    overflow: auto;
  }
  .tabs-content-list,.content{
    height: 100%;
  }
}

</style>
